module.exports = __webpack_public_path__ + "static/case_study_matrace_back-7bbf487786583e9338c98625d7805797.png";